import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  public URLconnect = environment.URL_API;

  constructor(
    private http: HttpClient
  ) { }

  async createPayment(data: any) {
    try {
      const response = await this.http.post<{ code: number, data: any }>(
        this.URLconnect + "/billingPayments",
        data
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updatePayment(paymentId: string, data: any) {
    try {
      const response = await this.http.put<{ code: number, data: any }>(
        this.URLconnect + "/billingPayments/" + paymentId,
        data
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getPaymentsByClient(clientId: string) {
    try {
      const response = await this.http.get<{ code: number, data: any[] }>(
        this.URLconnect + "/billingPayments/client/" + clientId
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getPaymentByCycle(clientId: string, billingCycleId: string) {
    try {
      const response = await this.http.get<{ code: number, data: any }>(
        this.URLconnect + `/billingPayments/client/${clientId}/cycle/${billingCycleId}`
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getPaymentsByCycleId(billingCycleId: string) {
    try {
      const response = await this.http.get<{ code: number, data: any[] }>(
        this.URLconnect + "/billingPayments/cycle/" + billingCycleId
      ).toPromise();

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  
  async getBillingHistory(clientId: string) {
    try {
      const response = await this.http.get<{ code: number, data: any[] }>(
        this.URLconnect + `/billingPayments/history/${clientId}`
      ).toPromise();

      return response.data;

    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}